import { render, staticRenderFns } from "./premium-offer.vue?vue&type=template&id=5f66ede2&"
import script from "./premium-offer.vue?vue&type=script&lang=js&"
export * from "./premium-offer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports